export default __webpack_public_path__ + "static/media/back_webtoon_04.e6b899f8.png";